module.exports = __webpack_public_path__ + "img/green-leaf-branch.6dd97ada.svg";